import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from './error-handler.service';
import { DocNote } from '@models/ui/doc-note.model';

@Injectable({
  providedIn: 'root'
})
export class DocNoteService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService, private appConfigService: AppConfigService) { }

  updateDocNote(docNote: DocNote): Observable<DocNote> {
    return this.http.put<DocNote>(`${this.appConfigService.getConfig().webApi}/api2/docNotes/${docNote.docNoteId}`, docNote)
      .pipe(catchError(this.errorHandler.handleError<DocNote>(`update doc note`)));
  }

  createDocNote(docNote: DocNote): Observable<DocNote> {
    return this.http.post<DocNote>(`${this.appConfigService.getConfig().webApi}/api2/docNotes`, docNote)
      .pipe(catchError(this.errorHandler.handleError<DocNote>(`create doc note`)));
  }
}
